import React from 'react'
import { axios } from '../handlers/RequestHandler'
import { URL } from '../config';
import Notification from '../handlers/Notification';
import { bitwise } from '../utils';

/**
 * @description this configures the base URL to make it point to
 * the current company, this behavior can be overriden by passing
 * through an entire URL with protocol
 * @example
 * build in URL: /branches/2
 * overriden URL: https://www.google.com.ve
 * @type {string}
 */
const baseURL = `${URL}${localStorage.getItem('companyId')}`
axios.defaults.baseURL = baseURL

/**
 * @description this parses an object and turns it into a query string
 * excluding empty, null and undefined values
 * @param filters
 * @returns {string}
 */
export const mapQueryString = (filters, appendingQueryString = false) => {
    return Object.entries(filters)
        .filter(entry => entry[1] !== '' && entry[1] !== null && entry[1] !== undefined)
        .map((entry, index) => {
            return `${index === 0 && !appendingQueryString ? '?' : '&'}${entry[0]}=${entry[1]}`
                /*.replaceAll(/\s+/gm, '') // removes all new lines, tabs and spaces
                .trim()*/
        }).join('')
}

const files = require.context('./', true, /\.js$/i)
const resources = files.keys() // gets all directory urls
    .filter($0 => $0 !== './index.js') // exclude this file from the list of urls
    .map($0 => ({ file: files($0).default, info: $0 })) // executes and read each file
    .filter($0 => typeof $0.file === 'function') // verifies that the file exports a function

const api = {}

resources.forEach($0 => {
    api[$0.info.split('.')[1].replace('/', '')] = $0.file({ axios, mapQueryString, baseURL })
})

/**
 * @description this allow to use withApiService to wrap a component
 * and automatically inject all the api services into that component as props under the `api` attribute
 * @param WrappedComponent
 * @returns {function(*): *}
 */
export const withApiService = (WrappedComponent) => (props) => (
    <WrappedComponent
        {...props}
        api={api}
        bitwise={bitwise}
        notification={Notification} />
)

export default api



// WEBPACK FOOTER //
// ./src/api/index.js